<template>
    <div v-if="store.state.isModalOpenThree" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-lg modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h1 class="mb-0">{{ selectionItem.name }} - Update Status</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

              <div class="px-3 pb-3 pt-1">
                <div class="mb-3">
                  <label for="expectedSalary" class="form-label">Remarks</label>
                  <input type="text" v-model="formData.remarks"  class="form-control" id="expectedSalary" placeholder="Enter your Remarks">
                </div>

                <button class="btn btn-primary" @click="handleSubmit" :disabled="loading">
                  Save
                </button>
              </div>

            </div>
        </div>
        <Loader v-if="loader"/>

    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import {computed, inject, ref} from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";

const props = defineProps({
  selectionItem: {
    type: Object,
    default: {}
  },
  jobApplication:{
    type: Object,
    default: {}
  }
})
const emit = defineEmits(['jobList']);
const store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loader = ref(false);
const loading = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const user = computed(() => store.state.user.user)

const formData = ref({
  remarks: null,
})

const {
  updateJobSelectionStatus,
} = handleHrPayroll();

const handleSubmit = async() => {
  loading.value = true;
  let query = `?company_id=${$route.params.companyId}`;
  let selectionStatusData = {}
  selectionStatusData.job_application_id = props.jobApplication.id;
  selectionStatusData.selection_status_id = props.selectionItem.id;
  selectionStatusData.remarks = formData.value.remarks;

  updateJobSelectionStatus(selectionStatusData, query)
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
        showSuccess(res.message)
        emit('jobList')
        onClickClose()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
      loading.value = false
  })
}

const onClickClose = () => {
  store.state.isModalOpenThree = false;
}

</script>
